import styled from "styled-components";


export const VideoContainer = styled.div`
    position: relative;
`


export const VideOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    top: 0;
    justify-content: center;
    align-items: center;

    z-index: 1;
 
    cursor: pointer;


    &:hover {
        &::after {
            opacity: 0.7;
        }
    }

    /* after element with background overlay */
    &::after {
        content: ""; /* Required for pseudo-elements */
        position: absolute; /* Positioning it within the parent element */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0; /* Put the background behind the content */
        opacity: 0.3;
        background-color: var(--c-theme-6) !important;
        border-radius: 1.5rem;
    }
`


export const PlayButton = styled.div`
    display: flex;
    width: 96px;
    height: 96px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;


    border-radius: 16px;
    opacity: 1;
    background: var(--Black-black-1, #0D0D0D);

    z-index: 2;
`
